"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Slider: function() {
        return _Slider.Slider;
    },
    renderSlider_unstable: function() {
        return _Slider.renderSlider_unstable;
    },
    sliderClassNames: function() {
        return _Slider.sliderClassNames;
    },
    sliderCSSVars: function() {
        return _Slider.sliderCSSVars;
    },
    useSliderState_unstable: function() {
        return _Slider.useSliderState_unstable;
    },
    useSliderStyles_unstable: function() {
        return _Slider.useSliderStyles_unstable;
    },
    useSlider_unstable: function() {
        return _Slider.useSlider_unstable;
    }
});
const _Slider = require("./Slider");
